// extracted by mini-css-extract-plugin
export default {"card":"Saa-z","carousel":"Taa-z"};